import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ModalController } from '@ionic/angular';
import { VideomodalComponent } from '../../components/videomodal/videomodal.component'
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';

@Component({
    selector: 'app-videobutton',
    templateUrl: './videobutton.component.html',
    styleUrls: ['./videobutton.component.scss'],
    standalone: false
})
export class VideobuttonComponent implements OnInit {
  @Input() video: any;

  private assetUrl = inject(AssetUrlService);

  constructor(public modalController:ModalController, public data: DataService) { }

  ngOnInit() {}

  select_(){
    console.log(this.video)
  }

  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: VideomodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (that.video?.title || '') },
      componentProps: {
        video: that.video,
        basepath: that.assetUrl.getMediaBase(),
      }
    });

    let payload = {
      token: this.data.token,
      title: 'Open video '+this.video.title,
      pathway_id: that.data.pathway ? that.data.pathway.id : '',
      condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
    };
    void this.data.apiPost('userappnav', payload);
    return await modal.present();
  }

  get thumbpath(){
    return encodeURI(this.assetUrl.mediaUrl(this.video.thumb));
  }
}